<template>
  <div>
    <div id="highlightsLoading" v-if="isLoading">
      <img class="d-none d-md-block mb-4" style="opacity: 0.6"
        src="/wp-content/themes/understrap-child/fidelio-templates/images/fourCardsPlaceholder.svg" alt="" />
      <img class="d-md-none mb-4" style="opacity: 0.6"
         src="/wp-content/themes/understrap-child/fidelio-templates/images/categoryPlacholderMobile.svg"
        alt="" />
    </div>

    <div v-if="highlights && highlights.length" class="bg-white mb-4 px-5 py-1 rounded-corners-10 highlight">
      <!-- Title -->
      <div class="text-primary my-3">
        <h5 v-if="!isDevMioActive" class="font-weight-bolder" style="font-size: x-large">
          {{ $t('CategoryPage.highlights') }}
        </h5>
      </div>

      <div class="splide highlightSplide newFeatureSlider" aria-label="Slider for highlights">
        <div class="sands-article-vueslidercontainer splide__track">
          <div class="splide__list">
            <div class="sands-article-detail mb-3 mt-3 mt-lg-2 splide__slide" v-for="(highlight, i) in highlights" :key="i">
              <div>
                <div class="p-0 align-items-stretch">
                  <div>
                    <a :href="constructCourseURL(highlight)">
                      <img v-if="highlight.teaserImage && highlight.teaserImage.xxx
                        " loading="lazy" itemprop="image" class="card-img ng-lazyloaded fixed-aspect-ratio"
                        :src="highlight.teaserImage.xxx" />
                      <img v-else src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/loading_Image_top_image.svg" alt="">
                    </a>
                    <div class="card border-0"></div>
                  </div>
                </div>
                <div class="pb-1 pt-3 d-flex flex-column h-100">
                  <a :href="constructCourseURL(highlight)">
                    <h4 v-if="highlight.name" class="text-break" itemprop="headline" style="font-size: larger">
                      {{ highlight.name }}
                    </h4>
                    <p v-if="highlight.abstract" class="article-excerpt" itemprop="abstract">
                      {{ highlight.abstract }}
                    </p>
                    <p v-if="highlight.localizedEndDate" class="article-excerpt mt-2" itemprop="abstract">
                      {{ formatEventDates(highlight.localizedStartDate, highlight.localizedEndDate) }}
                    </p>
                    <p class="text-dark" v-if="highlight && highlight.slogan && highlight.genre && highlight.genre == 'TUTORIAL'" >{{highlight.slogan}}</p>
                      <div v-if="highlight.genre != 'TUTORIAL' && highlight.experts && highlight.experts.length">
                          <span v-for="(expert, index) in  highlight.experts" :key="index" class="d-flex align-items-end flex-wrap">
                              <!-- a v-if="speaker._id" [routerLink]="['/autor/', speaker._id]" -->

                                <span v-if="expert.forename">
                                  <cite title="Expert name">{{expert.forename}}&nbsp;</cite>
                                </span>
                                <span v-if="expert.surname">
                                  <cite title="Expert surname">{{expert.surname}}</cite>
                                </span>
                                <span class="set_hyphens_initial" v-if="expert.company">
                                  <cite title="Expert company">&nbsp; | &nbsp;{{expert.company}}</cite>
                                </span>
                                <span v-if="!isLast">,&nbsp;</span>
                              <!-- /a -->
                            </span>
                      </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";
import helperFunction from "../../services/helperfunctions.js";
import { watch } from "vue";
import moment from 'moment';
import useElementVisible  from "../../services/elementVisibilityService.js" ;
import axios_queries from '../../services/axios_queries.js';
import CONCORD_QUERIES from "../../services/concord_queries.js"



export default {
  name: "categoryHighlights",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: true,
      highlights: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      firstTimeInViewport: true,
    }
  },

  /* disable eslint */
  created() {
      setTimeout(() => {
        this.box1Ref = document.getElementById('highlightsLoading');

        if (this.box1Ref) {
            const isVisible  = useElementVisible(this.box1Ref);
            if (isVisible && isVisible.value && isVisible.value == true) {
              this.firstTimeInViewport = false;
              this.loadInitialData();
            }
            watch(isVisible, () => {
            if (this.firstTimeInViewport && isVisible) {
                this.firstTimeInViewport = false;
                this.loadInitialData();
            }
            });
        }
      }, 500);
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
  },
  /* enable eslint */

  methods: {

    loadInitialData() {
      let highlightsLoadingParams = {
          page: 1,
          pagesize: 12,
          querystring: this.settingsPerm.cat,
          transientKey: this.settingsPerm.cat+'-cat-depending-highlights-vue',
          query:  "cat-depending-highlights-vue",
          url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-highlights-vue.json'
      };
      axios_queries.loadPublicData(highlightsLoadingParams).then((concordData) => {
        if (concordData && concordData != null && concordData != undefined && concordData != '') {
            if (concordData.advancedSearch && concordData.advancedSearch.highlights && concordData.advancedSearch.highlights.courses && concordData.advancedSearch.highlights.courses.Courses && concordData.advancedSearch.highlights.courses.Courses.length) {
                this.displayHighlights(concordData.advancedSearch.highlights.courses.Courses);
            }else{
              this.isLoading = false;
              this.emitter.emit('highloadsProcessed', true);
            }
        }else{
          this.isLoading = false;
            this.emitter.emit('highloads processed', true);
        }
      })
    },
    displayHighlights(highlights){
      this.isLoading = false;
      this.highlights = highlights;
      this.mount_splide();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_HIGHLIGHT;
      try {
        let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
        if (concordData && concordData.advancedSearch &&
            concordData.advancedSearch.highlights &&
            concordData.advancedSearch.highlights.courses &&
            concordData.advancedSearch.highlights.courses.Courses &&
            concordData.advancedSearch.highlights.courses.Courses.length)  {
           const newhighlights = concordData.advancedSearch.highlights.courses.Courses;
           this.highlights = [...this.highlights, ...newhighlights];
            this.mount_splide();
        }
      } catch (error) {
          console.log(error);
      }
    },

    addMovedEventListener() {
      this.splide.on("moved", (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.highlights.length);

        if (
          lastCardIndex === this.highlights.length - 2 &&
          this.highlights.length > this.metaCount
        ) {
          this.loadMoreData();
        }
      });
    },

    constructCourseURL(concordObject) {
      return helperFunction.sandsConstructRealUrl(concordObject);
    },

    formatEventDates(startDate, endDate) {
      const startMoment = moment(startDate, 'DD-MM-YYYY HH:mm:ss');
      const endMoment = moment(endDate, 'DD-MM-YYYY  HH:mm:ss');

      if (startMoment.isValid() && endMoment.isValid()) {
        const formattedStartDate = startMoment.format('DD. MMMM YYYY | HH:mm');
        const formattedEndDate = endMoment.format('HH:mm');

        return `${formattedStartDate} - ${formattedEndDate}`;
      } else {
        return "Invalid Date"; // Handle invalid dates gracefully
      }
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide(".highlightSplide", {
            classes: {
              prev: "splide__arrow--prev xx",
              next: "splide__arrow--next xxx",
              arrow: "splide__arrow xxxx",
            },
            perPage: 4,
            perMove: 1,
            rewindByDrag: true,
            gap: "1rem",
            breakpoints: {
              1600: {
                perPage: 4,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              1200: {
                perPage: 3,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              991: {
                perPage: 2,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              767: {
                perPage: 1,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: "0rem",
              left: "0rem",
            },
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },
  },

  
};
</script>